import { MASAR } from "@/constants/testIds";
import { Link } from "react-router-dom";
import BrandMark from "@/components/masar/BrandMark";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={MASAR.footer}
      className="bg-neutral-950 text-neutral-300 border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <BrandMark size={40} />
              <span className="font-semibold text-lg text-white tracking-tight">MASAR</span>
            </div>
            <p className="mt-4 text-neutral-400 max-w-sm leading-relaxed">
              {t("footer.blurb")}
            </p>
            <a
              data-testid={MASAR.footerDomain}
              href="https://masar.ltd"
              className="mt-6 inline-flex items-center gap-2 text-white hover:text-[#FF6A1A] transition-colors"
            >
              <span className="font-mono text-sm">masar.ltd</span>
              <span className="h-px w-8 bg-current" />
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500">
              {t("footer.navigate")}
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#how-it-works" className="hover:text-white transition-colors">{t("nav.howItWorks")}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t("nav.services")}</a></li>
              <li><a href="#coverage" className="hover:text-white transition-colors">{t("nav.coverage")}</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">{t("nav.faq")}</a></li>
              <li><a href="#support" className="hover:text-white transition-colors">{t("nav.support")}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500">
              {t("footer.contact")}
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a
                  data-testid={MASAR.footerEmail}
                  href="mailto:emailsupport@masar.ltd"
                  className="hover:text-white transition-colors"
                >
                  emailsupport@masar.ltd
                </a>
              </li>
              <li className="text-neutral-400">{t("footer.serving")}</li>
              <li className="text-neutral-400">{t("footer.hours")}</li>
            </ul>

            <div className="mt-6 flex flex-wrap gap-2">
              <a
                href="https://apps.apple.com/us/app/masar-community/id6787036272"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-appstore-link"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-[#FF6A1A] px-3 py-1 text-[11px] font-mono text-white transition-colors"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-[#FF6A1A]" />
                {t("footer.appstoreTag")}
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.masar.Cherif.app"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-playstore-link"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-[#FF6A1A] px-3 py-1 text-[11px] font-mono text-white transition-colors"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-[#FF6A1A]" />
                {t("footer.playTag")}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-neutral-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-neutral-500">
          <div>{t("footer.rights").replace("{year}", year)}</div>
          <div className="flex items-center gap-4 font-mono">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">{t("footer.privacyLink")}</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">{t("footer.termsLink")}</Link>
            <span>v1.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
